"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@home-health-notify/domain");
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: domain_1.RenderersType.StaticArrayLayout,
            label: "Services",
            scope: "#/properties/services",
            options: {
                detail: {
                    type: "VerticalLayout",
                    elements: [
                        {
                            type: domain_1.RenderersUIType.DataLabel,
                            label: "Service",
                            scope: "#/properties/service",
                        },
                        {
                            type: "Control",
                            label: false,
                            scope: "#/properties/status",
                            options: {
                                format: "radio",
                                oneOfStyle: {
                                    1: {
                                        color: "#c2131f",
                                    },
                                    2: {
                                        color: "#61a857",
                                    },
                                    3: {
                                        color: "#f5a10c",
                                    },
                                },
                            },
                        },
                    ],
                },
            },
        },
        {
            type: "Control",
            label: "Reason",
            scope: "#/properties/notes",
        },
    ],
};
